const STEPS = [
  {
    num: '01',
    title: 'Browse the catalog',
    desc: 'Scroll through phones, laptops, audio, and accessories with real prices in UGX — updated regularly.',
  },
  {
    num: '02',
    title: 'Tap "Order on WhatsApp"',
    desc: (
      <>
        Your message opens already filled in with the product name and price, sent straight to{' '}
        <strong className="font-bold text-text">0780 844 098</strong>.
      </>
    ),
  },
  {
    num: '03',
    title: 'Confirm & get delivery',
    desc: 'We confirm stock, agree on payment (MoMo, Airtel Money, or cash) and arrange delivery across Kampala or upcountry.',
  },
];

export function HowItWorks() {
  return (
    <section id="how" className="border-y border-white/10 bg-bg2 px-4 py-20 sm:px-8">
      <div className="mx-auto max-w-3xl">
        <div className="mb-12 text-center">
          <div className="mb-3 text-xs font-extrabold uppercase tracking-[0.2em] text-accent">
            The process
          </div>
          <h2 className="text-[clamp(1.8rem,4vw,2.5rem)] font-black tracking-tight">
            How ordering works
          </h2>
          <p className="mt-2 text-sm text-text-muted">
            No accounts, no checkout forms. Just three steps.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
          {STEPS.map((step) => (
            <div key={step.num} className="text-center">
              <div
                className="mb-4 text-5xl font-black leading-none tracking-tighter text-transparent"
                style={{ WebkitTextStroke: '1.5px rgba(0,229,160,0.3)' }}
              >
                {step.num}
              </div>
              <div className="mb-2 text-base font-extrabold">{step.title}</div>
              <p className="text-sm leading-relaxed text-text-muted">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
